export default {
  methods: {
    dataTableModalDestroy(modalId) {
      $("#historyModal").on("hidden.bs.modal", function (e) {
        $("#" + modalId)
          .DataTable()
          .destroy();
      });
    },
  },
};
